(function () {
  const SELECTOR = '[data-product-video-testimonials]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let activeModal = null;
  let lastFocus = null;

  function pauseVideo(video, reset) {
    if (!video) return;
    video.pause();
    if (reset) {
      try {
        video.currentTime = 0;
      } catch (error) {
        // Some browsers can reject currentTime before metadata is available.
      }
    }
  }

  function pauseAllVideos(except) {
    document.querySelectorAll(`${SELECTOR} video`).forEach((video) => {
      if (video !== except) pauseVideo(video, false);
    });
  }

  function syncModalSource(card, modalVideo) {
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.innerHTML = card.querySelector('video').innerHTML;
    modalVideo.poster = card.dataset.poster || '';
    modalVideo.load();
  }

  function closeModal(modal) {
    if (!modal) return;
    const modalVideo = modal.querySelector('[data-pvt-modal-video]');
    pauseVideo(modalVideo, true);
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    document.body.classList.remove('product-video-testimonials-modal-open');
    activeModal = null;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function openModal(root, card) {
    const modal = root.pvtModal || root.querySelector('[data-pvt-modal]');
    const modalVideo = modal?.querySelector('[data-pvt-modal-video]');
    if (!modal || !modalVideo) return;

    pauseAllVideos();
    if (activeModal && activeModal !== modal) closeModal(activeModal);

    lastFocus = document.activeElement;
    syncModalSource(card, modalVideo);
    modal.setAttribute('aria-hidden', 'false');
    modal.inert = false;
    document.body.classList.add('product-video-testimonials-modal-open');
    activeModal = modal;

    modalVideo.muted = false;
    modalVideo.volume = 1;
    modal.querySelector('[data-pvt-mute]')?.setAttribute('aria-pressed', 'false');
    modal.querySelector('[data-pvt-mute-label]')?.replaceChildren(document.createTextNode('Mute'));
    modal.querySelector('[data-pvt-close]')?.focus();
    modalVideo.play().catch(() => {});
  }

  function init(root) {
    if (root.dataset.pvtReady === 'true') return;
    root.dataset.pvtReady = 'true';

    const cards = root.querySelectorAll('[data-pvt-card]');
    const modal = root.querySelector('[data-pvt-modal]');
    const modalVideo = root.querySelector('[data-pvt-modal-video]');
    const closeButton = root.querySelector('[data-pvt-close]');
    const muteButton = root.querySelector('[data-pvt-mute]');
    const track = root.querySelector('[data-pvt-track]');
    const previousButton = root.querySelector('[data-pvt-previous]');
    const nextButton = root.querySelector('[data-pvt-next]');

    if (modal) {
      modal.inert = true;
      root.pvtModal = modal;
      document.body.append(modal);
    }

    function updateCarouselControls() {
      if (!track) return;
      const hasOverflow = track.scrollWidth > track.clientWidth + 2;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

      if (previousButton) previousButton.hidden = !hasOverflow || atStart;
      if (nextButton) nextButton.hidden = !hasOverflow || atEnd;
    }

    function alignCarouselArrows() {
      if (!track) return;
      const carousel = track.closest('.product-video-testimonials__carousel');
      const firstCard = track.querySelector('[data-pvt-card]');
      if (!carousel || !firstCard) return;

      const carouselTop = carousel.getBoundingClientRect().top;
      const cardBounds = firstCard.getBoundingClientRect();
      const cardCenter = cardBounds.top - carouselTop + cardBounds.height / 2;

      [previousButton, nextButton].forEach((button) => {
        if (button) button.style.top = `${cardCenter}px`;
      });
    }

    function updateCarouselLayout() {
      updateCarouselControls();
      alignCarouselArrows();
    }

    function scrollCarousel(direction) {
      if (!track) return;
      track.scrollBy({
        left: direction * Math.max(track.clientWidth * 0.82, 160),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    previousButton?.addEventListener('click', () => scrollCarousel(-1));
    nextButton?.addEventListener('click', () => scrollCarousel(1));
    track?.addEventListener('scroll', updateCarouselControls, { passive: true });
    window.addEventListener('resize', updateCarouselLayout);
    if (track && 'ResizeObserver' in window) {
      new ResizeObserver(updateCarouselLayout).observe(track);
    }
    requestAnimationFrame(updateCarouselLayout);

    cards.forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;

      video.addEventListener('play', () => card.classList.add('is-playing'));
      video.addEventListener('pause', () => card.classList.remove('is-playing'));
      video.addEventListener('ended', () => card.classList.remove('is-playing'));

      card.addEventListener('mouseenter', () => {
        if (reduceMotion.matches || !window.matchMedia('(hover: hover)').matches) return;
        pauseAllVideos(video);
        video.muted = true;
        video.play().catch(() => {});
      });

      card.addEventListener('mouseleave', () => {
        pauseVideo(video, true);
      });

      card.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        openModal(root, card);
      });

      card.addEventListener('keydown', (event) => {
        if (event.target.closest('a')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openModal(root, card);
      });
    });

    closeButton?.addEventListener('click', () => closeModal(modal));

    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal(modal);
    });

    modalVideo?.addEventListener('click', () => {
      if (modalVideo.paused) {
        pauseAllVideos(modalVideo);
        modalVideo.play().catch(() => {});
      } else {
        modalVideo.pause();
      }
    });

    modalVideo?.addEventListener('play', () => pauseAllVideos(modalVideo));

    muteButton?.addEventListener('click', () => {
      if (!modalVideo) return;
      modalVideo.muted = !modalVideo.muted;
      muteButton.setAttribute('aria-pressed', modalVideo.muted ? 'true' : 'false');
      muteButton.querySelector('[data-pvt-mute-label]').textContent = modalVideo.muted ? 'Unmute' : 'Mute';
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) closeModal(activeModal);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach(init);
  });
})();
